<template>
  <div class="view moment-detail" data-name="moment-detail">
    <div
      class="moment-detail__container"
      data-in-out
      data-in-out-animation="slide"
      data-in-out-order="0"
      data-in-out-delay="0.4"
    >
      <component
        v-for="(component, index) in $store.state.posts[$route.params.slug].structure"
        :key="index"
        :is="component.frontId"
        :data="component"
      />
    </div>
  </div>
</template>

<script>
import engine from '../scripts/engine';
import scroll from '../scripts/scroll';
import BlogHero from '@/components/blog/BlogHero.vue';
import BlogTextBlock from '@/components/blog/BlogTextBlock.vue';
import BlogQuote from '@/components/blog/BlogQuote.vue';
import BlogImage from '@/components/blog/BlogImage.vue';
import BlogWall from '@/components/blog/BlogWall.vue';
import BlogVideo from '@/components/blog/BlogVideo.vue';

export default {
  name: 'moment-detail',

  components: {
    BlogHero,
    BlogTextBlock,
    BlogQuote,
    BlogImage,
    BlogWall,
    BlogVideo,
  },

  data() {
    return {
      medium: [],
    };
  },

  mounted() {
    engine.add(this.scroll, 'detail-scroll', true);
    this.$nextTick(() => scroll.setBoundries(this.$el));

    this.$on('reload-boundries', () => {
      this.$nextTick(() => scroll.setBoundries(this.$el));
    });
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled(200);
      this.$el.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
    },
  },

  beforeDestroy() {
    engine.remove('live-scroll');
  },
};
</script>

<style lang="scss" scoped>
.moment-detail {
  &__container {
    position: relative;
    width: calc(100% - ((100vw / 32) * 11));
    left: calc((100vw / 32) * 7);
    padding: calc((100vh / 18) * 4) 0px;

    @include mq($until: ipadL) {
      left: calc((100vw / 32) * 4);
      width: calc(100% - ((100vw / 32) * 7));
      padding: calc((100vh / 18) * 6) 0px;
    }

    .blog-block {
      margin: calc((100vh / 18) * 2) 0px;

      &:first-of-type {
        margin-top: 0px;
      }

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
